import { Layout, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ConditionalRenderer, Header, SideNavbar } from "components";
import { useCurrentUserContext } from "providers";
import { sidebarHideRoutes } from "./constants";
import { Tabs } from "components/sidebar-nav/Tabs";
import { useEffect, useState } from "react";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";
import { LiveIcon, SandboxIcon } from "icons";
import Cookies from "js-cookie";
import { useRecoilState } from "recoil";
import { activeEnviornment } from "store/atom";
import styles from "./styles.module.scss";

export function AppLayout({ authenticated, children }: any) {
  const [activeTab, setActiveTab] = useRecoilState<any>(activeEnviornment);

  const { user } = useCurrentUserContext();
  const { pathname } = useLocation();

  // const [activeTab, setActiveTab] = useState(
  //   getCurrentEnviornment() || ENVIORNMENTS.LIVE
  // );

  const navigate = useNavigate();

  const pathnameWithoutId = pathname.split("/")[1] || "";

  const isShowSidebar = !sidebarHideRoutes.includes(pathnameWithoutId);
  const cookie = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);

  useEffect(() => {
    sessionStorage.setItem(ENVIORNMENTS.ENVIORNMENT, activeTab);
  }, [activeTab]);

  useEffect(() => {
    const current = getCurrentEnviornment();
    if (!cookie) {
      localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
    }

    if (
      // `${current}_userId` &&
      localStorage.getItem(`${current}_userId`) &&
      cookie
    ) {
      navigate(window.location.pathname + window.location.search);
    }
  }, []);

  const tabsArr = [
    {
      title: "Live",
      key: "live",
      icon: LiveIcon,
      color: "black",
      activeColor: "white",
    },
    {
      title: "Sandbox",
      key: "sandbox",
      icon: SandboxIcon,
    },
  ];

  const handleChangeEnviornment = async (newEnviornment: any) => {
    if (
      !localStorage.getItem(`${ENVIORNMENTS.LIVE}_userId`) &&
      !localStorage.getItem(`${ENVIORNMENTS.SANDBOX}_userId`)
    ) {
      return;
    }
    if (localStorage.getItem(`${newEnviornment}_userId`)) {
      navigate("m2c-dashboard");
      window.location.reload();
    } else {
      navigate("/");
      window.location.reload();
    }

    // Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
    // localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
    // localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
    // setLoading(true);
    // try {
    //   await getData({
    //     params: {
    //       secret_id: user?.secret_id,
    //     },
    //   });
    // } catch (error) {
    // } finally {
    //   setLoading(false);
    //   navigate("/");
    //   localStorage.setItem(ENVIORNMENT, newEnviornment);
    //   window.location.reload();
    // }

    // saveUserData(null);
  };
  return (
    <Layout
      style={{ minHeight: "100dvh", maxHeight: "100dvh", overflow: "hidden" }}
    >
      <Header showHeader={authenticated} />
      <Layout>
        <ConditionalRenderer condition={isShowSidebar}>
          {user && <SideNavbar />}
        </ConditionalRenderer>
        <Layout>
          <Layout.Content style={{ backgroundColor: "white" }}>
            <div style={{ height: "100%" }}>{children}</div>
          </Layout.Content>
          <ConditionalRenderer
            condition={
              user?.switch ||
              window.location.pathname === "/" ||
              window.location.pathname === "/forgot-password"
            }
          >
            <div className={styles.tabsWrapper}>
              <div>
                <Tabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  tabsArr={tabsArr}
                  handleClick={handleChangeEnviornment}
                />
              </div>
            </div>
          </ConditionalRenderer>
        </Layout>
      </Layout>
    </Layout>
  );
}
